import React from "react";

// reactstrap components
import { Button, Container, Row, Col } from "reactstrap";

class BeneficiariesHeader extends React.Component {
  render() {
    return (
      <>
        <div className="position-relative">
          {/* Hero for FREE version */}
          <section className="section section-hero section-shaped">
            {/* Background circles */}
            <div className="shape shape-style-1 shape-default">
              <span className="span-150" />
              <span className="span-50" />
              <span className="span-50" />
              <span className="span-75" />
              <span className="span-100" />
              <span className="span-75" />
              <span className="span-50" />
              <span className="span-100" />
              <span className="span-50" />
              <span className="span-100" />
            </div>
            <Container className="shape-container d-flex align-items-center py-lg">
              <div className="col px-0">
              <br /><br />
                <Row className="align-items-center justify-content-center">
                    
                  <Col className="text-center" lg="8">
                    
                    <h1 className="text-white">EMMA AND GRACE FOUNDATION</h1>
                    <p className="lead text-white">
                     Our Beneficiaries
                    </p>
                    <div className="btn-wrapper mt-5">
                      <Button
                        className="btn-white btn-icon mb-3 mb-sm-0"
                        color="default"
                        href="/donate"
                        size="lg"
                      >
                        <span className="btn-inner--icon mr-1">
                          <i className="ni ni-credit-card" />
                        </span>
                        <span className="btn-inner--text">Donate</span>
                      </Button>{" "}
                      <Button
                        className="btn-icon mb-3 mb-sm-0"
                        color="default"
                        href="/social-platform"
                        size="lg"
                      >
                        <span className="btn-inner--icon mr-1">
                          <i className="ni ni-briefcase-24" />
                        </span>
                        <span className="btn-inner--text">
                          <span className="text-warning mr-1">Join</span>
                          Us
                        </span>
                      </Button>
                    </div>
                    <div className="mt-5">
                      <small className="text-white font-weight-light mb-0 mr-2">
                      Let there be light… a star must shine!
                      </small>
                      
                    </div>
                  </Col>
                </Row>
                <br /><br /><br />
              </div>
            </Container>
            {/* SVG separator */}
            <div className="separator separator-bottom separator-skew zindex-100">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                preserveAspectRatio="none"
                version="1.1"
                viewBox="0 0 2560 100"
                x="0"
                y="0"
              >
                <polygon
                  className="fill-white"
                  points="2560 0 2560 100 0 100"
                />
              </svg>
            </div>
          </section>
        </div>
      </>
    );
  }
}

export default BeneficiariesHeader;